import { render, staticRenderFns } from "./JobParcelasView.vue?vue&type=template&id=1329680f&scoped=true"
import script from "./JobParcelasView.vue?vue&type=script&setup=true&lang=js"
export * from "./JobParcelasView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./JobParcelasView.vue?vue&type=style&index=0&id=1329680f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1329680f",
  null
  
)

export default component.exports